import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import AuthUserContext from './context';
import { withFirebase } from '../firebase';

const withAuthorization = condition => Component => {
  class WithAuthorization extends React.Component {
      
    componentDidMount() {
      this.listener = this.props.firebase.auth.onAuthStateChanged(
        uid => {
          if (!condition(uid)) {
            this.props.history.push('/login');
          }
        },
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Consumer>
          {currentUser =>
            condition(currentUser) ? <Component {...this.props} /> : null
          }
        </AuthUserContext.Consumer>      
        );
    }
  }

  return compose(
    withRouter,
    withFirebase,
  )(WithAuthorization);
};

export default withAuthorization;